import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { getUser, signIn as sendSignInRequest } from '../api/auth';
import { siteTracer } from '../api/site';
// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import {
  browserSessionPersistence,
  FacebookAuthProvider,
  signOut as FireBaseSignOut,
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  setPersistence,
  signInWithPopup,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAxuRBshKq0Zf5P0Kj5figOLB_aUYaSuZM',
  authDomain: 'tanyaegyetem-d996a.firebaseapp.com',
  projectId: 'tanyaegyetem-d996a',
  storageBucket: 'tanyaegyetem-d996a.firebasestorage.app',
  messagingSenderId: '676783400954',
  appId: '1:676783400954:web:ecff9aafaaab7a1848a643',
  measurementId: 'G-W47GQ2LRSX',
};

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  const auth = getAuth(app);
  const googleProvider = new GoogleAuthProvider();
  const facebookProvider = new FacebookAuthProvider();
  setPersistence(auth, browserSessionPersistence);

  useEffect(() => {
    (async function () {
      const result = await getUser();

      if (result.isOk) {
        setUser(result.data);
      } else {
        siteTracer({ action_type: 'NAVIGATION', route_visit: '/main' });
      }

      setLoading(false);
    })();
  }, [loading]);

  const ReloadUserRights = () => {
    setLoading(true);
  };
  const signIn = useCallback(async (loginData) => {
    const result = await sendSignInRequest(loginData);

    if (result.isOk) {
      localStorage.setItem('token', result.data.token);
      const u = await getUser();
      if (u.isOk) {
        setUser(u.data);
        if (u.data.activeSubscriptions.length > 0) {
          return u;
        }
        return {
          isOk: false,
          noSubscription: true,
          message: 'Nincs aktív előfizetés',
        };
      }
    }
    return { isOk: false, message: 'Hibás felhasználónév vagy jelszó' };
  }, []);

  const signOut = useCallback(() => {
    setUser(undefined);
    localStorage.removeItem('token');
    FireBaseSignOut(auth);
  }, []);

  const signInWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      localStorage.setItem('token', result.user.accessToken);

      const u = await getUser();
      if (u.isOk) {
        setUser(u.data);
        if (u.data.activeSubscriptions.length > 0) {
          return u;
        } else {
          return {
            isOk: false,
            noSubscription: true,
            message: 'Nincs aktív előfizetés',
          };
        }
      }
    } catch (error) {
      console.error('Google belépés hiba:', error);
    }
  };

  const signInWithFacebook = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      console.log('Facebook belépés sikeres:', result.user);
    } catch (error) {
      console.error('Facebook belépés hiba:', error);
    }
  };

  const UserStatus = () => {
    const [user, setUser] = useState(null);
    const auth = getAuth();

    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
      });

      return () => unsubscribe();
    }, [auth]);

    return user;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        signIn,
        signOut,
        signInWithGoogle,
        signInWithFacebook,
        ReloadUserRights,
        UserStatus,
        loading,
      }}
      {...props}
    />
  );
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
